'use client';

import PropTypes from 'prop-types';
import { useState } from 'react';
import StudentArtwork from 'components/student-artworks/student-artwork';
import StudentArtworkViewer from 'components/student-artworks/student-artwork-viewer';

export const StudentArtworksWithViewer = ({
	studentArtworks,
	Container,
	enforceMaxObjectWidth,
}) => {
	const [showObjectViewer, setShowObjectViewer] = useState(false);
	const [activeObjectIndex, setActiveObjectIndex] = useState(0);

	const handleObjectClick = (e, index) => {
		e.preventDefault();
		setShowObjectViewer(true);
		setActiveObjectIndex(index);
	};

	const handleCloseClick = () => {
		setShowObjectViewer(false);
	};

	return (
		<div>
			<Container>
				{studentArtworks?.map((artwork, index) => {
					return (
						<StudentArtwork
							index={index}
							enforceMaxWidth={enforceMaxObjectWidth}
							handleObjectClick={handleObjectClick}
							key={artwork._id}
							artwork={artwork}
						/>
					);
				})}
			</Container>
			{showObjectViewer && (
				<StudentArtworkViewer
					artworks={studentArtworks}
					initialActiveObjectIndex={activeObjectIndex}
					handleCloseClick={handleCloseClick}
				/>
			)}
		</div>
	);
};
StudentArtworksWithViewer.propTypes = {
	Container: PropTypes.any,
	enforceMaxObjectWidth: PropTypes.bool,
	studentArtworks: PropTypes.array,
};
